import React from 'react';

const FounderPage = () => {
  const trustees = [
    { id: 1, name: "Mr. Rameshwar Sonekar", qualification: "B.Sc.", designation: "Founder, President", category: "OBC", img: "assets/img/team/MrRameshwarSonekar.jpeg" },
    { id: 2, name: "Mr. Brij Mohan Singh", qualification: "B.E. (Computer)", designation: "Vice-President cum Managing Advisor", category: "Gen.", img: "assets/img/team/Mr.BrijMohanSingh.jpeg" },
    { id: 3, name: "Dr. K.S. Chaudhary", qualification: "M.Com", designation: "Secretary", category: "OBC", img: "assets/img/team/Dr.K.S.Chaudhary.png" },
    { id: 4, name: "Mr. Basant Kumar Uikey", qualification: "12th", designation: "Co-Secretary", category: "OBC", img: "assets/img/team/Mr.BasantUikey.jpeg" },
    { id: 5, name: "Smt. Eshu Mandlwar", qualification: "MSW", designation: "Treasurer", category: "OBC", img: "assets/img/team/miss.Eshu Mandalwar.jpeg" },
    { id: 6, name: "Mr. Tahel Singh Patle", qualification: "BSW", designation: "Member", category: "OBC", img: "assets/img/team/Tahelsinghpatle.jpeg" },
    { id: 7, name: "Dr. K.S. Chaudhary", qualification: "12th", designation: "Member", category: "ST", img: "assets/img/team/Dr.K.S.Chaudhary.png" }
];



    return (
        <>
         

          

<section className="about-section inner-page">
                <div className="container">
                    <h1>Founder / Board of Trustees</h1>
                    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                            <thead>
                                <tr>
                                    <th style={tableHeaderStyle}>S.I.</th>
                                    
                                    <th style={tableHeaderStyle}> Profile</th>
                                    <th style={tableHeaderStyle}> Name</th>
                                    <th style={tableHeaderStyle}>Qualification</th>
                                    <th style={tableHeaderStyle}>Designation</th>
                                     <th style={tableHeaderStyle}>Category</th>
                                    {/* <th style={tableHeaderStyle}>PAN</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {trustees.map((trustee) => (
                                    <tr key={trustee.id}>
                                        <td style={tableCellStyle}>{trustee.id}</td>
                                        <td style={tableCellStyle}>
    <img src={trustee.img} alt={trustee.name} style={{ width: "100px", height: "100px", borderRadius: "5px" }} />
</td>
                                        <td style={tableCellStyle}>{trustee.name}</td>
                                        <td style={tableCellStyle}>{trustee.qualification}</td>
                                        <td style={tableCellStyle}>{trustee.designation}</td>
                                        <td style={tableCellStyle}>{trustee.category}</td>
                                       
                                           {/*  <td style={tableCellStyle}>{trustee.pan}</td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            <section className="space" id="team-sec">
  <div className="container">
    <div className="title-area text-center">
      <span className="sub-title after-none before-none">
        <i className="far fa-heart text-theme" /> Our Volunteer
      </span>
      <h2 className="sec-title">Meet The Optimistic Volunteer</h2>
    </div>
    <div className="row gy-40">
      {/* Single Item */}
      <div className="col-lg-3 col-md-6">
        <div className="th-team team-card3">
          <div className="team-img">
            <img src="assets/img/team/MrRameshwarSonekar.jpeg" alt="Team" />
          </div>
          <div className="team-card-content">
            <h3 className="box-title">
              <a href="team-details.html">Mr. Rameshwar Sonekar</a>
            </h3>
            <span className="team-desig">Founder, President</span>
            <div className="th-social style2">
              <a target="_blank" href="https://facebook.com/">
                <i className="fab fa-facebook-f" />
              </a>
              <a target="_blank" href="https://twitter.com/">
                <i className="fab fa-twitter" />
              </a>
              <a target="_blank" href="https://instagram.com/">
                <i className="fab fa-instagram" />
              </a>
              <a target="_blank" href="https://behance.com/">
                <i className="fab fa-behance" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Single Item */}
      <div className="col-lg-3 col-md-6">
        <div className="th-team team-card3">
          <div className="team-img">
            <img src="assets/img/team/Mr.BrijMohanSingh.jpeg" alt="Team" />
          </div>
          <div className="team-card-content">
            <h3 className="box-title">
              <a href="team-details.html">Mr. Brij Mohan Singh</a>
            </h3>
            <span className="team-desig">Vice-President cum Managing Advisor</span>
            <div className="th-social style2">
              <a target="_blank" href="https://facebook.com/">
                <i className="fab fa-facebook-f" />
              </a>
              <a target="_blank" href="https://twitter.com/">
                <i className="fab fa-twitter" />
              </a>
              <a target="_blank" href="https://instagram.com/">
                <i className="fab fa-instagram" />
              </a>
              <a target="_blank" href="https://behance.com/">
                <i className="fab fa-behance" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Single Item */}
      <div className="col-lg-3 col-md-6">
        <div className="th-team team-card3">
          <div className="team-img">
            <img src="assets/img/team/Mr.BasantUikey.jpeg" alt="Team" />
          </div>
          <div className="team-card-content">
            <h3 className="box-title">
              <a href="team-details.html">Mr. Basant Kumar Uikey</a>
            </h3>
            <span className="team-desig">Co-Secretary</span>
            <div className="th-social style2">
              <a target="_blank" href="https://facebook.com/">
                <i className="fab fa-facebook-f" />
              </a>
              <a target="_blank" href="https://twitter.com/">
                <i className="fab fa-twitter" />
              </a>
              <a target="_blank" href="https://instagram.com/">
                <i className="fab fa-instagram" />
              </a>
              <a target="_blank" href="https://behance.com/">
                <i className="fab fa-behance" />
              </a>
            </div>
          </div>
        </div>
      </div>
     
      {/* Single Item */}
      <div className="col-lg-3 col-md-6">
        <div className="th-team team-card3">
          <div className="team-img">
            <img src="assets/img/team/miss.Eshu Mandalwar.jpeg" alt="Team" />
          </div>
          <div className="team-card-content">
            <h3 className="box-title">
              <a href="team-details.html">Smt. Eshu Mandlwar</a>
            </h3>
            <span className="team-desig">Treasurer</span>
            <div className="th-social style2">
              <a target="_blank" href="https://facebook.com/">
                <i className="fab fa-facebook-f" />
              </a>
              <a target="_blank" href="https://twitter.com/">
                <i className="fab fa-twitter" />
              </a>
              <a target="_blank" href="https://instagram.com/">
                <i className="fab fa-instagram" />
              </a>
              <a target="_blank" href="https://behance.com/">
                <i className="fab fa-behance" />
              </a>
            </div>
          </div>
        </div>
      </div>
    
      {/* Single Item */}
     

     

      <div className="col-lg-3 col-md-6">
        <div className="th-team team-card3">
          <div className="team-img">
            <img src="assets/img/team/Dr.K.S.Chaudhary.png" alt="Team" />
          </div>
          <div className="team-card-content">
            <h3 className="box-title">
              <a href="team-details.html">Dr. K.S. Chaudhary</a>
            </h3>
            <span className="team-desig">Volunteer</span>
            <div className="th-social style2">
              <a target="_blank" href="https://facebook.com/">
                <i className="fab fa-facebook-f" />
              </a>
              <a target="_blank" href="https://twitter.com/">
                <i className="fab fa-twitter" />
              </a>
              <a target="_blank" href="https://instagram.com/">
                <i className="fab fa-instagram" />
              </a>
              <a target="_blank" href="https://behance.com/">
                <i className="fab fa-behance" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Single Item */}
       <div className="col-lg-3 col-md-6">
        <div className="th-team team-card3">
          <div className="team-img">
            <img src="assets/img/team/Tahelsinghpatle.jpeg" alt="Team" />
          </div>
          <div className="team-card-content">
            <h3 className="box-title">
              <a href="team-details.html">Mr. Tahel Singh Patle</a>
            </h3>
            <span className="team-desig">Volunteer</span>
            <div className="th-social style2">
              <a target="_blank" href="https://facebook.com/">
                <i className="fab fa-facebook-f" />
              </a>
              <a target="_blank" href="https://twitter.com/">
                <i className="fab fa-twitter" />
              </a>
              <a target="_blank" href="https://instagram.com/">
                <i className="fab fa-instagram" />
              </a>
              <a target="_blank" href="https://behance.com/">
                <i className="fab fa-behance" />
              </a>
            </div>
          </div>
        </div>
      </div> 
      {/* Single Item */}
      {/* <div className="col-lg-3 col-md-6">
        <div className="th-team team-card3">
          <div className="team-img">
            <img src="assets/img/team/team_3_7.png" alt="Team" />
          </div>
          <div className="team-card-content">
            <h3 className="box-title">
              <a href="team-details.html">Mr. Rup Lal</a>
            </h3>
            <span className="team-desig">Volunteer</span>
            <div className="th-social style2">
              <a target="_blank" href="https://facebook.com/">
                <i className="fab fa-facebook-f" />
              </a>
              <a target="_blank" href="https://twitter.com/">
                <i className="fab fa-twitter" />
              </a>
              <a target="_blank" href="https://instagram.com/">
                <i className="fab fa-instagram" />
              </a>
              <a target="_blank" href="https://behance.com/">
                <i className="fab fa-behance" />
              </a>
            </div>
          </div>
        </div>
      </div> */}
     
    </div>
  </div>
</section>


        </>
    );
};

const tableHeaderStyle = {
    border: '1px solid #ddd',
    padding: '10px',
    backgroundColor: '#f2f2f2',
    fontWeight: 'bold',
    textAlign: 'left'
};

const tableCellStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left'
};

export default FounderPage;
